export const EnumInsuranceFor = {
  employee: false,
  family: true,
};
